<ng-container [ngSwitch]="pageLoadingState$ | async">
  <ng-container *ngSwitchCase="LoadingState.Pending">
    <div fxLayout style="margin-bottom: 24px; align-items: center; justify-content: center">
      <mat-spinner fxLayout fxLayoutAlign="center" [diameter]="30"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Success">
    <ng-container *ngIf="listingReviews$ | async as listingReviews">
      <ng-container *ngIf="listingReviews && listingReviews.length > 0">
        <ng-template [ngTemplateOutlet]="inviteHosts"></ng-template>
      </ng-container>
      <ng-container *ngIf="listingReviews && listingReviews.length === 0">
        <ng-template [ngTemplateOutlet]="inviteHostsNoData"></ng-template>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Error">
    <ng-template [ngTemplateOutlet]="inviteHostsError"></ng-template>
  </ng-container>
</ng-container>

<ng-template #inviteHostsError>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <div>
      <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.7819 30.169V79.0313H14.6938V30.1487"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
          fill="#D0CDD4" />
      </svg>
    </div>

    <h2>Oops, an error has occurred</h2>

    <ng-template [ngTemplateOutlet]="complete"></ng-template>
  </div>
</ng-template>

<ng-template #inviteHostsNoData>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <div>
      <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.7819 30.169V79.0313H14.6938V30.1487"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
          fill="#D0CDD4" />
      </svg>
    </div>

    <h2>No listings found</h2>

    <span class="text-center">
      {{ 'CORE.PRODUCT_NAME' | transloco }} did not find any listings under this account. You need at least one listing
      to test out the features available on {{ 'CORE.PRODUCT_NAME' | transloco }}.
    </span>

    <ng-template [ngTemplateOutlet]="continue"></ng-template>
  </div>
</ng-template>

<ng-template #inviteHosts>
  <ng-container *ngIf="listingReviews$ | async as listings">
    <div
      class="container"
      fxLayout="column"
      fxLayoutAlign="start start"
      fxLayoutGap="32px"
      *ngIf="listings?.length > 0">
      <section fxLayout="column" fxLayoutGap="20px">
        <h2>
          {{ listings.length }}
          {{ 'listing' + (listings.length > 1 ? 's' : '') }}
          {{ 'require' + (listings.length > 1 ? '' : 's') }}
          the primary host
        </h2>
      </section>

      <section style="width: 100%" *ngIf="listings?.length > 0">
        <div *ngFor="let listing of listings" class="cohosted-listing">
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <img
              *ngIf="listing.picture"
              [src]="listing.picture"
              [alt]="listing.name"
              fxFlex="32px"
              class="listing-img" />
            <span fxFlex class="listing-name ellipsis">{{ listing.name }}</span>
          </div>
        </div>
      </section>

      <section fxLayout="column" fxLayoutGap="20px">
        <span fxFlex class="night text__medium">
          The primary host of {{ platformText ? platformText.withArticle : 'a' }} listing must be connected to
          Hospitable to be able to manage the listing. Hospitable will invite the hosts you add below to connect their
          {{ platformText ? platformText.name : '' }} account. We will copy you and our support team on the email in
          case they reach out with any questions
        </span>
      </section>

      <section fxLayout="column" fxLayoutGap="0">
        <ng-template [ngTemplateOutlet]="inviteHostsForm"></ng-template>
      </section>
    </div>

    <div
      fxLayout
      fxLayoutGap="18px"
      style="margin-top: 24px"
      fxLayoutAlign="space-between center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <button (click)="goBack()">Back</button>

      <button mat-flat-button (click)="continue()">Continue</button>
    </div>
  </ng-container>
</ng-template>

<ng-template #inviteHostsForm>
  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="0px">
    <label fxFlex class="form-label" for="code">Full name</label>
    <label fxFlex class="form-label" for="code">Email</label>
  </div>

  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px" *ngFor="let invitee of invitees" class="invitee">
    <mat-form-field class="fw">
      <input matInput [(ngModel)]="invitee.name" fxFlex type="text" placeholder="Eg. John Doe" />
    </mat-form-field>

    <mat-form-field class="fw">
      <input matInput [(ngModel)]="invitee.email" fxFlex type="email" [placeholder]="'john@doe.com'" />
    </mat-form-field>
  </div>

  <button class="button__text" (click)="invitees.push({ name: '', email: '' })">+ Add another</button>
</ng-template>
